import React from "react";
import styled, { css } from "styled-components";
import { translate } from "react-i18next";
import { pompadour } from "../colors";

const AsapPicker = props => (
  <PickerView>
    {props.items.filter(item => item).map((item, index) =>
        ((props.hiddenIndexes && !props.hiddenIndexes.includes(index)) || !props.hiddenIndexes) && (
          <Item
            disabled={item.disabled}
            key={item.key}
            active={props.activeItemIndex === index}
            onClick={() => {
              if (!item.disabled) {
                props.onClickItem(item, index);
              }
            }}
          >
            {props.t(item.value)}
            {item.tooltip && <Tooltip>{item.tooltip}</Tooltip>}
          </Item>
        ))}
    {props.disabled && <Item disabled>{props.t(props.disabledText)}</Item>}
  </PickerView>
);

export default translate()(AsapPicker);

const PickerView = styled.div`
  font-weight: 500;
  font-size: 12pt;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  margin-bottom: 20px;
`;

const Item = styled.div`
  margin-right: 16px;
  font-weight: 500;
  font-size: 12pt;
  color: ${pompadour};
  letter-spacing: 0;
  text-transform: uppercase;

  border-bottom: 2px transparent solid;

  opacity: 0.4;
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  transition: opacity 0.3s ease, border-color 0.3s ease;
  will-change: opacity, border-color;

  ${props =>
    props.active &&
    css`
      opacity: 1;
      border-color: ${pompadour};
    `};
`;

const Tooltip = styled.span`
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  position: absolute;
  z-index: 1;

  ${Item}:hover & {
    visibility: visible;
  }
`;



// WEBPACK FOOTER //
// ./src/components/AsapPicker.js